import type { AppInputHandlers, AppInputTypeHookOptions } from '../types/interfaces'

export const useAppInputText = ({
  onKeyupEnter,
  model,
}: AppInputTypeHookOptions): AppInputHandlers => {
  const handleInput = (): void => {}

  const handleChange = (): void => {}

  const handleKeyupEnter = (): void => {
    onKeyupEnter(model.value)
  }

  return {
    handleInput,
    handleChange,
    handleKeyupEnter,
  }
}
